import { Injectable } from '@angular/core';
import { Transport } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { factorHeightDuration } from '../../../../../config/constants';

@Injectable({
  providedIn: 'root'
})
export class CardService {
  // Methods
 /**
   * Calculates the height of the card based on its duration.
   */
  setHeightAccordingToDuration(durationMinutes: number, isLocationCard: boolean, cardElement: HTMLElement): void {
    cardElement.style.height = isLocationCard ? 'fit-content' : durationMinutes * factorHeightDuration + 'px';
  }

  /**
   * Calculates the margin top for the card based on its start time and previous card.
   */
  setMarginTopAccordingToStartTime(
    indexCard: number,
    startDate: Date,
    dailyPoints: any[],
    cardElement: HTMLElement
  ): { marginTop: number, topPositionTransportList: number } {
    if (!dailyPoints || !dailyPoints.length || !cardElement || !startDate) return { marginTop: 0, topPositionTransportList: 0 };

    const startTimeValue = startDate.getHours() + startDate.getMinutes() / 60 === 0
      ? 24
      : startDate.getHours() + startDate.getMinutes() / 60;

    let marginTop = 0;
    let topPositionTransportList = 0;

    if (indexCard === 0) {
      const offsetMinutes = (startTimeValue - 9) * 60;
      marginTop = offsetMinutes * factorHeightDuration > 48 ? offsetMinutes * factorHeightDuration + 24 : 24;
      topPositionTransportList = marginTop + 12 < 48 ? -48 : -(marginTop + 12);
      cardElement.style.marginTop = marginTop + 'px';
    } else {
      const previousCard = dailyPoints[indexCard - 1];
      if (!previousCard) return { marginTop, topPositionTransportList };

      const prevStart = previousCard.startDate.getHours() + previousCard.startDate.getMinutes() / 60;
      const prevDuration = previousCard.duration;
      const prevEnd = prevStart + (prevDuration / 60);
      const currentStart = startTimeValue;
      const gapInMinutes = (currentStart - prevEnd) * 60;

      marginTop = gapInMinutes * factorHeightDuration - 16;
      topPositionTransportList = marginTop + 12 < 48 ? -48 : -(marginTop + 12);
      cardElement.style.marginTop = `${marginTop}px`;
    }

    return { marginTop, topPositionTransportList };
  }

  /**
   * Checks if the transport list overflows the card.
   */
  isTransportListOverflow(transportList: Transport[], marginTop: number): boolean {
    if (transportList.length === 1) return false;
    const heightTransportListContent = transportList.length * 48;
    const maxHeight = marginTop + 12 < 48 ? 48 : marginTop + 12;
    return heightTransportListContent > maxHeight;
  }

  /**
   * Checks if the card duration is 15 minutes.
   */
  isDuration15Minutes(durationMinutes: number): boolean {
    return durationMinutes === 15;
  }

  /**
   * Calculates the start date for the location point (id = 0).
   */
  getStartDateForLocationPoint(
    indexCard: number,
    dailyPoints: any[],
    startDate: Date
  ): Date {
    const locationPoint = dailyPoints.find(point => point.id === 0);
    const totalTransportDuration = locationPoint?.transportList.reduce((total, transport) => total + transport.duration, 0) || 0;
    const previousPoint = dailyPoints[indexCard - 1];
    if (!previousPoint) return startDate;
    const previousPointEndTime = previousPoint.endDate;
    const locationStartDate = new Date(previousPointEndTime.getTime() + totalTransportDuration * 60000);
    return locationStartDate || startDate;
  }

  /**
   * Checks if the card is a location card.
   */
  isLocationCard(id: number): boolean {
    return id === 0;
  }

}
